<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import NoiseReductionComparison from '$lib/PageSections/DataDrivenResults/NoiseReductionComparison.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import AverageSaved from '$lib/PageSections/Charts/AverageSaved/AverageSaved.svelte';
	import curtains from './images/AdobeStock_493491283.jpeg';
	import meditate from './images/Cant_Meditate_A.jpg';
	import kitchenInstall from './images/IW-MED-Install-03-RGB-09-06-14.jpg';
	import customerReview from './images/img_2.png';
	import bookshelf from './images/installing_frame_bookshelf.jpg';
	import youtubeThumb from './images/uxt6iMknNMs.jpg';
</script>

<Section backgroundColor="white">
	<h2>The Treble With Windows</h2>

	<p>
		Windows (even double paned) are notoriously bad insulators - especially
		against noise. Whether its dogs barking, cars driving by, construction, or
		any of the other noisy nuisances we encounter in our neighborhoods, windows
		can make it seem like the sound is coming from inside the house.
	</p>
	<Image src={meditate} />
	<p>
		Soundproofing your home can be a challenge. Window replacement is an option
		for some, but can be a very costly and intrusive process and often only
		reduce noise by 25%. The total costs of window replacements (including
		labor) <a href="/resources/blog/increase-home-resale-value-with-inserts"
			>aren’t a great option for increasing your home’s resale value</a
		>.
	</p>
</Section>
<NoiseReductionComparison />
<Section>
	<p>
		Other 'soundproof' options - like heavy blinds or 'sound absorbing’ curtains
		- will only dampen outside noise, but also block out the things your windows
		do best - bathe your home in natural light. This is where window inserts
		really shine.
	</p>
	<Image src={curtains} />
</Section>
<Section>
	<h2>Achieve Quiet With Indow Acoustic Inserts</h2>
	<p>
		WIth our patented Snug Fit compression tubing and premium acrylic glazing,
		our Acoustic Grade Window Inserts can block up to 70% of the noise coming
		through your windows. That’s about as close as you can get to soundproofing
		your windows without building a wall over them.
	</p>
	<p>
		But the best part? They blend in with your existing window frames and let
		light flow in freely. In fact, if it wasn’t for how much quieter they make
		your home - you’d forget they were there!
	</p>
	<Image src={bookshelf} />
	<p>
		Our inserts are custom cut to your exact window dimensions and require no
		modifications to your windows or window frames. With a provided laser
		measure device and our proprietary measurement software, you can rest easy
		knowing your inserts will fit snugly and create an airtight pocket to seal
		out sound, as well as extreme temperatures!
	</p>

	<Bubble backgroundColor="blue">
		<h2 class="font !text-indow-white">See It In Action</h2>
		<p class="!text-indow-white">
			What does a 70% reduction in noise sound like? Listen to how much the
			music is reduced even from inside the window!
		</p>
		<div class="overflow-hidden rounded-lg">
			<Youtube
				src="https://www.youtube.com/watch?v=uxt6iMknNMs"
				posterImageSrc={youtubeThumb}
			/>
		</div>
	</Bubble>
</Section>
<Section>
	<h2>More Quiet, More Comfort, More Savings</h2>
	<p>
		In addition to a substantial reduction in noise, Indow Acoustic Inserts also
		provide significant thermal insulating properties, keeping your home warmer
		in winter, cooler in summer, and realizing an average 20% in energy savings.
		It's a win-win-win for your pocket book, the planet, and your day-to-day
		comfort.
	</p>
	<AverageSaved title={null} />
	<p>
		Our air-tight seal not only keeps noise out and your ideal temperature in,
		but it also blocks dust, pollen, and other airborne particles, but that
		doesn’t mean you’ll have to live in a hermetically sealed home. With a
		gentle tug on the provided D-ring, you can break the seal and remove the
		inserts whenever you want to open your windows and let in some fresh air.
	</p>
</Section>
<Section>
	<h2>Why Choose Indow?</h2>
	<p>
		Your custom noise-reducing inserts will be manufactured by hand right here
		in the USA using premium materials that will last the lifetime of your home.
		That’s why we offer a <a href="/warranties/residential-lifetime-warranty"
			>Lifetime Warranty</a
		>
		and a <a href="/warranties/snug-fit-guarantee">Snug Fit Guarantee</a> on every
		product we ship out the door.
	</p>
	<Image src={kitchenInstall} />
	<p>
		Our team of Fit Specialists are available to ensure you get the right
		product and the right solution for your unique window problems and will make
		sure you get our best available pricing.
	</p>
	<p>
		So what are you waiting for? Get in touch with us today and put your window
		worries behind you.
	</p>
	<Button href="/indow-cost">GET A FREE ESTIMATE</Button>
</Section>
<Section backgroundColor="grey-light">
	<h2>Customer Stories</h2>
	<Image src={customerReview} alt="A loving family." />
	<p class="!text-indow-blue italic">
		“After moving in, we realized just how busy the street was because it was so
		noisy we could not sleep at all. Neither could our infant. (The inserts)
		came on time and were installed so easily, I couldn't believe it! The
		difference in sound was unbelievable.”
	</p>
	<p>-Maggie F, Portland, Oregon</p>
	<a class="quote text-indow-blue italic" href="/resources/case-studies"
		>Read more case studies.</a
	>
</Section>

<Reviews />
<GetAFreeEstimate />
